import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

class ColorPicker extends Component {

    constructor(props) {
        super(props);
        this.state = { 
            selectedColor: 'white'
        };
    }

    pickColor(color) {
        this.setState({
            selectedColor: color
        })

        this.props.callback({
            marbleColor: {
                'stat': color,
                'cost': 5
            },
        });
    }

    render() {
        return (
            <div className="customize-wrapper">
                {this.props.colors.map((color, i) => {
                    const Div = styled.div`
                    background-color: ${color}`;

                    return (
                        <Div 
                        key={i}
                        onClick={() => this.pickColor(color)}
                        className={'customize-color-item' + (this.state.selectedColor === color ? ' selectedColor' : '')}/>
                        );
                })}
            </div>
        )
    }
}

ColorPicker.propTypes = {
    colors: PropTypes.arrayOf(PropTypes.string).isRequired,
    callback: PropTypes.func.isRequired
};

export default ColorPicker; // Don’t forget to use export default!


// WEBPACK FOOTER //
// ./src/Customize/ColorPicker.js